
export default {
  props: ['title', 'color', 'size', 'img', 'date', 'back', 'mobile'],
  methods: {
    toPage (url) {
      this.$router.push(url)
    }
  }

}
